import { defineComponent, onMounted, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import _ from 'lodash';
import { useMessageNotification } from '@hems/component';
import { HomeApplianceService } from '@hems/service';
import { MainTitle, ApplianceUnregistered } from '@/components';
import { APPLIANCE_TYPE } from '@/config/constants';
import { ApplianceListContainer, ApplianceDetailContainer } from '@/containers';
export default defineComponent({
    name: 'HomeAppliance',
    components: {
        MainTitle,
        ApplianceUnregistered,
        ApplianceListContainer,
        ApplianceDetailContainer,
    },
    setup() {
        const store = useStore();
        const { t } = useI18n();
        const messageNotification = useMessageNotification();
        const homeApplianceService = new HomeApplianceService(window.axiosInstance.axios);
        const state = reactive({
            homeId: Number(store.state.user.homeId),
            show: false,
            listData: [],
            selectedItem: null,
        });
        const getApplianceList = async () => {
            try {
                return await homeApplianceService.getApplianceList(state.homeId).then((res) => {
                    return res.filter((item) => {
                        return (item.profile_cd === APPLIANCE_TYPE.HEAT_PUMP ||
                            item.profile_cd === APPLIANCE_TYPE.AIR_CONDITIONER ||
                            item.profile_cd === APPLIANCE_TYPE.SMART_PLUG ||
                            item.profile_cd === APPLIANCE_TYPE.TV);
                    });
                });
            }
            catch (e) {
                console.error(e);
                return [];
            }
        };
        const loadData = async () => {
            try {
                state.listData = [];
                const data = await getApplianceList();
                state.listData = data;
            }
            catch (e) {
                console.error(e);
                state.listData = [];
            }
        };
        const showDetail = (item) => {
            state.selectedItem = item;
        };
        const afterControl = async () => {
            state.show = false;
            state.selectedItem = null;
            await messageNotification.setMessageNotification('success', t('common.success'), '').open();
            await loadData();
            state.show = true;
        };
        onMounted(async () => {
            await loadData();
            state.show = true;
        });
        return {
            state,
            _,
            showDetail,
            afterControl,
        };
    },
});
